/* ClearAir add-ons: video modal, reviews "show more", scroll-to-buy */
(function () {
  'use strict';
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- Video modal ---------- */
  var vm = document.querySelector('[data-video-modal]');
  var vEl = vm && vm.querySelector('[data-video-el]');
  var vCap = vm && vm.querySelector('[data-video-caption]');
  var list = [], idx = 0;
  function playAt(i) {
    if (!vEl || !list.length) return;
    idx = (i + list.length) % list.length;
    var b = list[idx];
    vEl.src = b.getAttribute('data-src');
    if (b.getAttribute('data-poster')) vEl.poster = b.getAttribute('data-poster'); else vEl.removeAttribute('poster');
    if (vCap) vCap.textContent = b.getAttribute('data-caption') || '';
    var p = vEl.play(); if (p && p.catch) p.catch(function () {});
    $$('[data-video-prev],[data-video-next]', vm).forEach(function (n) { n.hidden = list.length < 2; });
  }
  function close() {
    if (!vm || !vm.classList.contains('is-open')) return;
    vm.classList.remove('is-open'); vm.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('cd-lock');
    if (vEl) { vEl.pause(); vEl.removeAttribute('src'); vEl.load(); }
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-video-open]');
    if (b && vm) {
      e.preventDefault();
      list = $$('[data-video-open]', b.closest('.ugc__row') || document);
      vm.classList.add('is-open'); vm.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('cd-lock');
      playAt(list.indexOf(b));
      return;
    }
    if (e.target.closest('[data-video-close]')) close();
    else if (e.target.closest('[data-video-prev]')) playAt(idx - 1);
    else if (e.target.closest('[data-video-next]')) playAt(idx + 1);
    else if (e.target.closest('[data-vmodal-buy]')) {
      close();
      var t = document.getElementById('paket');
      if (t) t.scrollIntoView({ behavior: 'smooth', block: 'center' });
      else window.location.href = '/products/nasal-stick';
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  if (vEl) {
    var sx = null;
    vEl.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    vEl.addEventListener('touchend', function (e) {
      if (sx === null) return; var dx = e.changedTouches[0].clientX - sx; sx = null;
      if (Math.abs(dx) > 50 && list.length > 1) playAt(idx + (dx < 0 ? 1 : -1));
    });
    vEl.addEventListener('ended', function () { if (list.length > 1) playAt(idx + 1); });
  }

  /* ---------- Reviews ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-reviews-more]');
    if (b) {
      var listEl = b.closest('section').querySelector('[data-reviews]');
      var hidden = $$('.rcard.is-hidden', listEl);
      hidden.slice(0, 4).forEach(function (c) { c.classList.remove('is-hidden'); });
      if (hidden.length <= 4) b.hidden = true;
      return;
    }
    var j = e.target.closest('[data-review-jump]');
    if (j) {
      var card = document.getElementById('rev-' + j.getAttribute('data-review-jump'));
      if (card) { card.classList.remove('is-hidden'); card.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
    }
  });

  /* ---------- Scroll to buy box ---------- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-scroll-buy]'); if (!a) return;
    var href = a.getAttribute('href') || '';
    if (href.charAt(0) !== '#') return;
    var t = document.querySelector(href); if (!t) return;
    e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });
})();

/* Hide cart badge when 0 */
(function () {
  function upd() { document.querySelectorAll('.cah__count').forEach(function (el) { if (el.textContent.trim() === '0' || el.textContent.trim() === '') el.setAttribute('data-zero', ''); else el.removeAttribute('data-zero'); }); }
  upd();
  document.querySelectorAll('.cah__count').forEach(function (el) { new MutationObserver(upd).observe(el, { childList: true, characterData: true, subtree: true }); });
})();

/* Header menu (Kontakt, Vår vision …) */
(function () {
  var h = document.querySelector('[data-cah]'); if (!h) return;
  var btn = h.querySelector('[data-cah-toggle]');
  function set(open) { h.classList.toggle('is-menu-open', open); btn.setAttribute('aria-expanded', open ? 'true' : 'false'); }
  btn.addEventListener('click', function () { set(!h.classList.contains('is-menu-open')); });
  document.addEventListener('click', function (e) { if (!e.target.closest('[data-cah]')) set(false); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') set(false); });
})();

/* Benefits bubbles */
(function () {
  document.querySelectorAll('[data-bnf]').forEach(function (s) {
    var cards = s.querySelectorAll('[data-bnf-card]'), n = cards.length, cur = 0, timer = null, touched = false;
    function show(i) {
      cur = (i + n) % n;
      s.querySelectorAll('[data-bnf-i]').forEach(function (b) {
        var on = Number(b.getAttribute('data-bnf-i')) === cur;
        b.classList.toggle('is-active', on);
        if (b.getAttribute('role') === 'tab') b.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      cards.forEach(function (c, k) { c.classList.toggle('is-active', k === cur); });
    }
    s.addEventListener('click', function (e) {
      var b = e.target.closest('[data-bnf-i]'); if (!b) return;
      touched = true; clearInterval(timer); show(Number(b.getAttribute('data-bnf-i')));
    });
    if (n > 1 && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        en.forEach(function (x) {
          clearInterval(timer);
          if (x.isIntersecting && !touched) timer = setInterval(function () { show(cur + 1); }, 3500);
        });
      }, { threshold: 0.4 }).observe(s);
    }
  });
})();

/* Sticky "Köp nu": add the selected bundle (default Köp 2, få 1) and open the cart */
document.addEventListener('click', function (e) {
  var b = e.target.closest('[data-sticky-cta-btn]'); if (!b) return;
  var bundle = document.querySelector('[data-bundle]');
  var add = bundle && document.querySelector('[data-add-button]');
  if (!add || add.disabled) return;
  e.preventDefault(); e.stopImmediatePropagation();
  if (!bundle.querySelector('input[type=radio]:checked')) {
    var def = bundle.querySelector('input[type=radio][data-qty="3"]') || bundle.querySelector('input[type=radio]');
    if (def) def.click();
  }
  add.click();
}, true);

/* Gallery dots + mouse drag (arrows hidden; touch swipe handled in theme.js) */
document.querySelectorAll('[data-gallery]').forEach(function (g) {
  var main = g.querySelector('.gallery__main');
  var slides = Array.prototype.slice.call(g.querySelectorAll('.gallery__slide'));
  if (!main || slides.length < 2) return;
  var dots = document.createElement('div'); dots.className = 'gallery__dots';
  slides.forEach(function (s, k) {
    var b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', String(k + 1));
    b.addEventListener('click', function (e) { e.stopPropagation(); show(k); });
    dots.appendChild(b);
  });
  main.appendChild(dots);
  function cur() { return slides.findIndex(function (s) { return s.classList.contains('is-active'); }); }
  function show(n) {
    n = (n + slides.length) % slides.length;
    var t = g.querySelector('[data-thumb="' + slides[n].dataset.mediaId + '"]');
    if (t) t.click(); else slides.forEach(function (s, k) { s.classList.toggle('is-active', k === n); });
  }
  function sync() { var i = cur(); Array.prototype.forEach.call(dots.children, function (d, k) { d.classList.toggle('is-active', k === i); }); }
  sync();
  new MutationObserver(sync).observe(main, { attributes: true, subtree: true, attributeFilter: ['class'] });
  // mouse drag for desktop
  var mx = null;
  main.addEventListener('mousedown', function (e) { mx = e.clientX; });
  window.addEventListener('mouseup', function (e) {
    if (mx === null) return; var dx = e.clientX - mx; mx = null;
    if (Math.abs(dx) > 40) show(cur() + (dx < 0 ? 1 : -1));
  });
  main.addEventListener('dragstart', function (e) { e.preventDefault(); });
});

/* Delivery estimate: today + 3-7 business days, localized */
(function () {
  document.querySelectorAll('[data-eta]').forEach(function (el) {
    var loc = el.getAttribute('data-locale') || 'sv-SE';
    function add(n) { var d = new Date(); var c = 0; while (c < n) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) c++; } return d; }
    var a = add(Number(el.getAttribute('data-min') || 3)), b = add(Number(el.getAttribute('data-max') || 7));
    function mon(d) { return new Intl.DateTimeFormat(loc, { month: 'short' }).format(d).replace(/\.$/, ''); }
    var from = a.getMonth() === b.getMonth() ? String(a.getDate()) : a.getDate() + ' ' + mon(a);
    var to = b.getDate() + ' ' + mon(b);
    var txt = el.getAttribute('data-tpl').replace('{from}', from).replace('{to}', to);
    var s = el.querySelector('[data-eta-text]'); if (s) s.textContent = txt;
    el.hidden = false;
  });
})();
